import AScene from "../../library/ExtendedObjects/AScene.js";

export default class Game_Numpad
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, gameUI)
    {
        this.scene = scene;
        this.onSubmit = null;

        this.numberPad_Number = this.scene.addText(143, 245, "", 55, null, 1, gameUI);
        this.numberPad_Number.tint = 0x000000;
        this.numberPad_Keys = [];

        this.numberLine = gameUI.create(143, 264, "count_numberline");

        let spacing = {
            startX: 80,
            startY: 307,
            spacingX: 67,
            spacingY: 59
        };

        let keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "backspace"];
        let index = 0;

        for(let y = 0; y < 4; y++)
        {
            for (let x = 0; x < 3; x++) 
            {
                let xPos = spacing.startX + (x * spacing.spacingX);
                let yPos = spacing.startY + (y * spacing.spacingY);
                let key =  keys[index];
                
                index++;
                if(key != "")
                {
                    let key_Btn = this.scene.addButton(xPos, yPos, "BTN_countkeypadOff", {frameOnDown: "BTN_countkeypadOn"}, ()=>{
                        if(key_Btn.text) this.numberPad_Number.text += key_Btn.text.text;
                        else this.numberPad_Number.text = this.numberPad_Number.text.slice(0, this.numberPad_Number.text.length - 1);

                        this.checkButtons();
                    }, gameUI);

                    this.numberPad_Keys.push(key_Btn);

                    key_Btn.yOrigin = yPos;
                    key_Btn.onPointerDown = ()=>{
                        if(key_Btn.input.enabled)
                        {
                            if(key_Btn.text) key_Btn.text.y = yPos + 8;
                            else if(key_Btn.graphic) key_Btn.graphic.y = yPos + 2;
                        }
                    };
                    key_Btn.onPointerUp = ()=>{
                        if(key_Btn.input.enabled)
                        {
                            if(key_Btn.text && key_Btn.input.enabled) key_Btn.text.y = yPos + 4;
                            else if(key_Btn.graphic) key_Btn.graphic.y = yPos - 2;
                        }
                    };

                    if (key == "backspace") {
                        key_Btn.graphic = gameUI.create(xPos, yPos - 2, "count_keypad_bckspc");
                    }
                    else {
                        let keyText = this.scene.addText(xPos, yPos + 4, key, 50, null, 1, gameUI);
                        keyText.tint = 0x61352E;
                        key_Btn.text = keyText;
                    }
                }
                else
                {
                    this.blankKey = gameUI.create(xPos, yPos, "BTN_countkeypadOn");
                }
            } 
        }

        this.submitButton = this.scene.addButton(143, 560, "BTN_submitOff", {frameOnDown: "BTN_submitOn"}, ()=>{
            if(this.onSubmit != null) this.onSubmit(parseInt(this.numberPad_Number.text));
            this.numberPad_Number.text = "";
            this.checkButtons();
        }, gameUI);

        this.checkButtons();
    }

    toggleVisible(toggle)
    {
        this.numberLine.alpha = toggle;
        this.submitButton.alpha = toggle;
        this.blankKey.alpha = toggle;
        
        for (let i = 0; i < this.numberPad_Keys.length; i++) 
        {
            this.numberPad_Keys[i].alpha = toggle;
            if(this.numberPad_Keys[i].text) this.numberPad_Keys[i].text.alpha = toggle;
            if(this.numberPad_Keys[i].graphic) this.numberPad_Keys[i].graphic.alpha = toggle;
        }
    }

    checkButtons()
    {
        let numLength = this.numberPad_Number.text.length;
        for (let i = 0; i < this.numberPad_Keys.length; i++) 
        {
            let key = this.numberPad_Keys[i];
            if (key.text) { //WE ARE CHECKING A NUMBER
                if (numLength >= 3) {
                    key.setFrame("BTN_countkeypadOn", false, false);
                    key.upFrame = "BTN_countkeypadOn";
                    key.text.y = key.yOrigin + 8;
                    key.disableInteractive();
                }
                else {
                    key.setFrame("BTN_countkeypadOff", false, false);
                    key.upFrame = "BTN_countkeypadOff";
                    key.text.y = key.yOrigin + 4;
                    key.setInteractive();
                }
            }
            else { //WE ARE CHECKING THE BACKSPACE
                if (numLength == 0) {
                    this.submitButton.setFrame("BTN_submitOn", false, false);
                    this.submitButton.upFrame = "BTN_submitOn";
                    this.submitButton.disableInteractive();

                    key.setFrame("BTN_countkeypadOn", false, false);
                    key.upFrame = "BTN_countkeypadOn";
                    key.graphic.y = key.yOrigin + 2;
                    key.disableInteractive();
                }
                else {
                    this.submitButton.setFrame("BTN_submitOff", false, false);
                    this.submitButton.upFrame = "BTN_submitOff";
                    this.submitButton.setInteractive();

                    key.setFrame("BTN_countkeypadOff", false, false);
                    key.upFrame = "BTN_countkeypadOff";
                    key.graphic.y = key.yOrigin - 2;
                    key.setInteractive();
                }
            }

        }
    }
}